'use client'
// import Header from '../component/header';
import Banner from '../component/banner';
import Footer from '../component/footer'
import SurveyQuestions from '../component/surveyquestions';
import SurveyContextProvider, { SurveyContext} from '../context/surveycontext';
import { Suspense, useContext, useEffect } from 'react';

function WLSurveyPage(){
    return (
        <Suspense>
            <SurveyContextProvider>
                <InternalSurveyPage></InternalSurveyPage>
            </SurveyContextProvider>
        </Suspense>
    );
};

const InternalSurveyPage = () =>{
    const {
        displayMessage,        
        bannerText,
        isError
    } = useContext(SurveyContext);
   
    

     useEffect ( () => {         

        document.title = 'Engagement Survey';

        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = 'https://encstorage01.blob.core.windows.net/shr-profileimages/E3favicon.png';  
    }, [])

    return (
        <>
        <Banner displayMessage={displayMessage} bannerText={bannerText} isError={isError} singleSurvey={false} wlSurvey={true} />
        <SurveyQuestions wlSurvey={true}/>
        <Footer singleSurvey={true}/>
        </>
    )
}

export default WLSurveyPage;